(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pm-360-view"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pm360) return;
    window.__pm360 = true;

    var ICON_360 =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><ellipse cx="12" cy="12" rx="9" ry="3.6"/><path d="m18.2 14.6 2.2.6-.6 2.2"/></svg>';
    var ICON_X =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var ICON_DRAG =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M8 12h8M8 12l3-3M8 12l3 3M16 12l-3-3M16 12l-3 3"/></svg>';

    function galleryFor(src) {
      var section = src.closest('.shopify-section') || document;
      return section.querySelector('media-gallery') || document.querySelector('media-gallery');
    }

    function mount() {
      var src = document.querySelector('.pm-360-src');
      if (!src) return;
      var gal = galleryFor(src);
      if (!gal || gal.querySelector('.pm-360-fab')) return;

      if (getComputedStyle(gal).position === 'static') gal.style.position = 'relative';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pm-360-fab';
      btn.innerHTML = ICON_360 + (src.getAttribute('data-label') || 'View in 360°');
      btn.addEventListener('click', function () {
        open(gal, (src.getAttribute('data-frames') || '').split('|'));
      });
      gal.appendChild(btn);
    }

    function open(gal, frames) {
      if (frames.length < 2 || gal.querySelector('.pm-360-ovl')) return;

      var ovl = document.createElement('div');
      ovl.className = 'pm-360-ovl';
      ovl.innerHTML =
        '<div class="pm-360-ovl__stage"><img class="pm-360-ovl__img" alt="" draggable="false"></div>' +
        '<button type="button" class="pm-360-ovl__close" aria-label="Close">' + ICON_X + '</button>' +
        '<div class="pm-360-ovl__load"><span></span></div>' +
        '<p class="pm-360-ovl__hint">' + ICON_DRAG + 'Drag to rotate</p>';
      gal.appendChild(ovl);

      var img = ovl.querySelector('.pm-360-ovl__img');
      var stage = ovl.querySelector('.pm-360-ovl__stage');
      var bar = ovl.querySelector('.pm-360-ovl__load span');
      var barBox = ovl.querySelector('.pm-360-ovl__load');
      var n = frames.length;
      var current = 0;
      var loaded = 0;
      var cache = [];

      img.src = frames[0];

      frames.forEach(function (u) {
        var im = new Image();
        im.onload = im.onerror = function () {
          loaded++;
          bar.style.width = Math.round((loaded / n) * 100) + '%';
          if (loaded === n) {
            barBox.classList.add('is-done');
            autospin();
          }
        };
        im.src = u;
        cache.push(im);
      });

      function show(i) {
        current = ((i % n) + n) % n;
        img.src = frames[current];
      }

      var spinTimer = null;
      function autospin() {
        var step = 0;
        spinTimer = setInterval(function () {
          step++;
          show(current + 1);
          if (step >= n) clearInterval(spinTimer);
        }, 70);
      }
      function stopSpin() {
        if (spinTimer) { clearInterval(spinTimer); spinTimer = null; }
      }

      /* one frame per ~22px of drag */
      var dragX = null;
      var dragFrame = 0;
      stage.addEventListener('pointerdown', function (ev) {
        stopSpin();
        dragX = ev.clientX;
        dragFrame = current;
        stage.classList.add('is-dragging');
        stage.setPointerCapture(ev.pointerId);
      });
      stage.addEventListener('pointermove', function (ev) {
        if (dragX === null) return;
        show(dragFrame + Math.round((ev.clientX - dragX) / 22));
      });
      function endDrag() {
        dragX = null;
        stage.classList.remove('is-dragging');
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);

      function onKey(ev) {
        if (ev.key === 'Escape') close();
        if (ev.key === 'ArrowRight') { stopSpin(); show(current + 1); }
        if (ev.key === 'ArrowLeft') { stopSpin(); show(current - 1); }
      }
      document.addEventListener('keydown', onKey);

      function close() {
        stopSpin();
        document.removeEventListener('keydown', onKey);
        ovl.remove();
      }
      ovl.querySelector('.pm-360-ovl__close').addEventListener('click', close);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }

    /* variant switches morph the media section and drop injected nodes */
    new MutationObserver(function () {
      if (document.querySelector('.pm-360-src') && !document.querySelector('.pm-360-fab')) mount();
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-bike-assembly"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pmBikeAssembly) return;
    window.__pmBikeAssembly = true;

    /* Two fixes over the original:
       1. NOT form.id — a product form contains <input name="id"> for the
          variant, and named controls shadow the element's own properties, so
          form.id returns that input element and the lookup never matched.
       2. Intercept the button click, not submit. Horizon registers its own
          document-level capture listener for submit (component.js on:submit)
          before this block's script runs, so intercepting submit fires after
          the theme has already started adding — re-submitting from there put
          the bike in the cart twice. */
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target instanceof Element ? e.target.closest('button[type="submit"]') : null;
        if (!btn || btn.disabled) return;

        var form = btn.form || btn.closest('form');
        if (!form) return;

        var formId = form.getAttribute('id');
        if (!formId) return;

        var asm = document.querySelector('.pm-asm[data-form="' + formId + '"]');
        if (!asm) return;

        var feeVariant = asm.getAttribute('data-fee-variant');
        if (!feeVariant) return;

        if (btn.__pmAsmDone) {
          btn.__pmAsmDone = false;
          return;
        }

        /* The radios sit outside the form and are attached to it with the
           form="" attribute, so they are NOT descendants — form.querySelector
           never found them. Query inside the block instead. */
        var checked = asm.querySelector('.pm-asm__radio:checked');
        if (!checked || checked.value.indexOf('(') === -1) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(feeVariant), quantity: qty }] }),
        })
          .catch(function () {})
          .finally(function () {
            btn.__pmAsmDone = true;
            btn.click();
          });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-frame-size"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pmFrameSizeReady) return;
    window.__pmFrameSizeReady = true;

    var IFRAME_BASE = 'https://bikesizing.cube.eu/iframe/';
    var ACCENT = '#E30613';
    /* Same endpoint + public key CUBE's own iframe uses; it publishes both in
       https://bikesizing.cube.eu/api/config/env.js, so nothing here is private. */
    var API = 'https://connect-api.cube.eu/bikesizing/api/v1/Size/getSizeRecommendation';
    var API_KEY = 'a50f4bac3f75485f8075cd7f00efb2cf';

    var ovl = null, lastTrigger = null, t = {}, currentId = '';

    function el(sel) { return ovl ? ovl.querySelector(sel) : null; }

    function figure() {
      /* Drawn here rather than borrowed, so it stays crisp at any size and needs no
         third-party asset. Laid out on real body proportions over a 356px figure
         (y 10 = crown, y 366 = floor): head 1/7.5 of height, shoulders at 18%,
         crotch at 52%, knee at 73%, fingertips at 63% — otherwise it reads as a
         robot. The two rules mark exactly what the fields ask for: full height on
         the left (crown to floor), inside leg on the right (crotch to floor). */
      return '' +
        '<svg class="pm-fsz-fig" viewBox="0 0 200 380" role="img" aria-hidden="true">' +
          '<g class="body">' +
            '<ellipse cx="100" cy="34" rx="19" ry="24"/>' +
            '<path d="M92 52h16v18H92z"/>' +
            '<path d="M100 62c-15 0-29 8-33 21l5 45-2 68h60l-2-68 5-45c-4-13-18-21-33-21z"/>' +
            '<path d="M66 86c-8 4-12 13-13 24l-6 105c-1 11 4 18 11 17 6-1 8-6 8-16l6-104z"/>' +
            '<path d="M134 86c8 4 12 13 13 24l6 105c1 11-4 18-11 17-6-1-8-6-8-16l-6-104z"/>' +
            '<path d="M70 196h28l-1 74-2 76c0 8-6 11-11 11s-9-3-9-11l-2-76z"/>' +
            '<path d="M130 196h-28l1 74 2 76c0 8 6 11 11 11s9-3 9-11l2-76z"/>' +
            '<rect x="64" y="352" width="34" height="14" rx="6"/>' +
            '<rect x="102" y="352" width="34" height="14" rx="6"/>' +
          '</g>' +
          '<g fill="none">' +
            '<path class="rule" d="M22 10v356"/>' +
            '<path class="cap" d="M13 10h18M13 366h18"/>' +
            '<path class="rule" d="M178 196v170"/>' +
            '<path class="cap" d="M169 196h18M169 366h18"/>' +
          '</g>' +
        '</svg>';
    }

    function build() {
      ovl = document.createElement('div');
      ovl.className = 'pm-fsz-ovl';
      ovl.setAttribute('role', 'dialog');
      ovl.setAttribute('aria-modal', 'true');
      ovl.hidden = true;
      ovl.innerHTML =
        '<div class="pm-fsz-ovl__box">' +
          '<div class="pm-fsz-ovl__bar">' +
            '<h2></h2>' +
            '<button type="button" class="pm-fsz-ovl__x" aria-label="">' +
              '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="pm-fsz-ovl__scroll">' +
            '<form class="pm-fsz-app" novalidate>' +
              '<h3 class="pm-fsz-app__title" data-fsz="heading"></h3>' +
              '<div class="pm-fsz-app__grid">' +
                '<div>' + figure() + '</div>' +
                '<div>' +
                  '<div class="pm-fsz-app__field">' +
                    '<label for="pm-fsz-h" data-fsz="height"></label>' +
                    '<div class="pm-fsz-app__input">' +
                      '<input id="pm-fsz-h" name="height" type="number" inputmode="numeric" min="100" max="230" step="1" autocomplete="off">' +
                      '<span class="pm-fsz-app__unit">cm</span>' +
                    '</div>' +
                  '</div>' +
                  '<div class="pm-fsz-app__field">' +
                    '<label for="pm-fsz-l" data-fsz="leg"></label>' +
                    '<div class="pm-fsz-app__input">' +
                      '<input id="pm-fsz-l" name="leg" type="number" inputmode="numeric" min="50" max="120" step="1" autocomplete="off">' +
                      '<span class="pm-fsz-app__unit">cm</span>' +
                    '</div>' +
                  '</div>' +
                  '<p class="pm-fsz-app__note" data-fsz="hint"></p>' +
                  '<p class="pm-fsz-app__err" data-fsz-err hidden role="alert"></p>' +
                '</div>' +
                '<div class="pm-fsz-app__col--out">' +
                  '<p class="pm-fsz-app__product" data-fsz-product></p>' +
                  '<button type="submit" class="pm-fsz-app__submit" data-fsz="submit"></button>' +
                  '<div class="pm-fsz-app__out" data-fsz-out hidden>' +
                    '<p class="pm-fsz-app__outlabel" data-fsz="result"></p>' +
                    '<p class="pm-fsz-app__size" data-fsz-size></p>' +
                    '<p class="pm-fsz-app__msg" data-fsz-msg hidden></p>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="pm-fsz-app__foot">' +
                '<p data-fsz="disclaimer"></p>' +
                '<a href="/pages/contact" data-fsz="stores"></a>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ovl);
      ovl.querySelector('.pm-fsz-ovl__x').addEventListener('click', close);
      ovl.addEventListener('click', function (e) { if (e.target === ovl) close(); });
      ovl.querySelector('form').addEventListener('submit', submit);
      return ovl;
    }

    function close() {
      if (!ovl || ovl.hidden) return;
      ovl.hidden = true;
      var frame = el('iframe');
      if (frame) frame.src = 'about:blank';
      document.documentElement.style.overflow = '';
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    function setText(node, text) { if (node) node.textContent = text || ''; }

    function showError(msg) {
      var box = el('[data-fsz-err]');
      if (!box) return;
      box.textContent = msg || '';
      box.hidden = !msg;
    }

    function showResult(size, second, msg) {
      var out = el('[data-fsz-out]');
      var sizeNode = el('[data-fsz-size]');
      var msgNode = el('[data-fsz-msg]');
      if (!out) return;
      if (size) {
        sizeNode.textContent = '';
        sizeNode.appendChild(document.createTextNode(size));
        if (second) {
          var em = document.createElement('em');
          em.textContent = t.or || 'or';
          sizeNode.appendChild(em);
          sizeNode.appendChild(document.createTextNode(second));
        }
      } else {
        sizeNode.textContent = '—';
      }
      setText(msgNode, msg);
      if (msgNode) msgNode.hidden = !msg;
      out.hidden = false;
    }

    function submit(e) {
      e.preventDefault();
      var hEl = el('#pm-fsz-h');
      var lEl = el('#pm-fsz-l');
      var btn = el('[data-fsz="submit"]');
      var height = parseFloat(String(hEl.value).replace(',', '.'));
      var leg = parseFloat(String(lEl.value).replace(',', '.'));

      if (!(height >= 100 && height <= 230)) {
        hEl.setAttribute('aria-invalid', 'true');
        hEl.focus();
        showError(t.req);
        return;
      }
      hEl.removeAttribute('aria-invalid');
      showError('');

      var payload = { idProduct: currentId, heightMeasurement: height };
      if (leg >= 40 && leg <= 140) payload.legMeasurement = leg;

      btn.disabled = true;
      var restore = btn.textContent;
      btn.textContent = t.loading || restore;

      fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'CubeAPI-Key': API_KEY },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          if (!d.sizesExist) { showResult(null, null, t.nosizes); return; }
          if (!d.recommendedSize) { showResult(null, null, t.notfound); return; }

          var msg = '';
          if (d.secondRecommendedSize) {
            msg = d.preferFirstRecommendation
              ? String(t.prefer || '').replace('[[size]]', d.recommendedSize)
              : t.between;
          }
          if (d.legRatioOutOfBounds) {
            msg = msg ? msg + ' ' + t.legbad : t.legbad;
          }
          showResult(d.recommendedSize, d.secondRecommendedSize, msg);
        })
        .catch(function () {
          /* Sizing service unreachable — hand the shopper CUBE's own iframe rather
             than a dead form. English there, but working beats translated-and-broken. */
          fallbackToIframe();
        })
        .then(function () {
          btn.disabled = false;
          btn.textContent = restore;
        });
    }

    function fallbackToIframe() {
      var scroll = el('.pm-fsz-ovl__scroll');
      if (!scroll || !lastTrigger) return;
      var src = IFRAME_BASE + encodeURIComponent(currentId) + '/' +
        (lastTrigger.getAttribute('data-cube-title') || 'bike') +
        '?language=' + encodeURIComponent(lastTrigger.getAttribute('data-cube-lang') || 'en') +
        '&color=' + encodeURIComponent(ACCENT).replace(/#/g, '%23');
      scroll.innerHTML = '<iframe title="" loading="lazy"></iframe>';
      var frame = scroll.querySelector('iframe');
      frame.setAttribute('title', lastTrigger.getAttribute('data-modal-title') || '');
      frame.style.height = '640px';
      frame.src = src;
    }

    function open(btn) {
      var id = btn.getAttribute('data-cube-id');
      if (!id) return;
      if (!ovl) build();
      currentId = id;
      lastTrigger = btn;

      try { t = JSON.parse(btn.getAttribute('data-i18n') || '{}'); } catch (err) { t = {}; }

      /* A previous open may have fallen back to the iframe — put the form back
         BEFORE writing the header, or the rebuild throws the header away. */
      if (!el('form')) { ovl.remove(); ovl = null; build(); }

      var titleText = btn.getAttribute('data-modal-title') || '';
      var closeText = btn.getAttribute('data-close-label') || 'Close';
      el('.pm-fsz-ovl__bar h2').textContent = titleText;
      el('.pm-fsz-ovl__x').setAttribute('aria-label', closeText);

      Array.prototype.forEach.call(ovl.querySelectorAll('[data-fsz]'), function (node) {
        setText(node, t[node.getAttribute('data-fsz')]);
      });
      setText(el('[data-fsz-product]'), btn.getAttribute('data-product-title') || '');
      el('[data-fsz-out]').hidden = true;
      showError('');
      el('#pm-fsz-h').value = '';
      el('#pm-fsz-l').value = '';

      ovl.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      el('.pm-fsz-ovl__x').focus();
    }

    /* Delegated: survives Horizon's variant-change morph of product-details. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pm-frame-size]');
      if (!btn) return;
      e.preventDefault();
      open(btn);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Only relevant after a fallback: CUBE's iframe posts its height as a bare number. */
    window.addEventListener('message', function (e) {
      var frame = el('iframe');
      if (!frame || !ovl || ovl.hidden) return;
      if (e.source !== frame.contentWindow) return;
      var h = parseInt(e.data, 10);
      if (h > 0 && h < 4000) frame.style.height = h + 'px';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-size-chart"] && !Shopify.designMode) return;
  try {
    /* PM size-system switcher (24.09.2026). Relabels the size buttons UK/US ↔ EU ↔ CM from the
     product's size_chart table. Variants are untouched — only the visible text changes. */
  (function () {
    if (window.__pmSizeSysReady) return;
    window.__pmSizeSysReady = true;
    var KEY = 'pm-size-sys';
    function pref() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function setPref(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function norm(h) {
      h = String(h || '').trim();
      if (/^eur?$/i.test(h)) return 'EU';
      if (/mondo|^cm$|foot length|pēdas/i.test(h)) return 'CM';
      return h;
    }
    function cols(t) {
      var out = {};
      (t.headers || []).forEach(function (h, i) {
        out[norm(h)] = t.orientation === 'columns' ? (t.rows[i] || []) : (t.rows || []).map(function (r) { return r[i]; });
      });
      return out;
    }
    // Kids sizes are often stored without their letter ("3" for 3Y, "5" for 5K).
    // Kids letters: C/K = infant–child, Y = youth. Infant shoes (INF/TD) look for C/K first;
    // other kids sizes up to 7 are youth (Y), 8+ are child (C). ".0" covers "24" vs "24.0".
    var INFANT = false;
    function pos(list, v) {
      if (!list) return -1;
      var n = parseFloat(v);
      var order = INFANT ? ['C', 'K', '', 'Y'] : (n <= 7 ? ['', 'Y', 'K', 'C'] : ['C', '', 'K', 'Y']);
      order.push('.0');
      for (var k = 0; k < order.length; k++) { var i = list.indexOf(v + order[k]); if (i !== -1) return i; }
      return -1;
    }
    function genderScore(title, gender) {
      var g = (gender || []).join(' ').toLowerCase(), t = String(title || '').toLowerCase();
      if (!g || !t) return 0;
      var gw = /women|girl|sieviet|meiten/.test(g);
      var gk = /kid|boy|girl|child|junior|bērn|zēn|meiten/.test(g);
      var gm = /men|vīrie|unisex/.test(g.replace(/women/g, '')) && !gw;
      if (/women|sieviet/.test(t)) return gw ? 0.5 : -0.5;
      if (/kid|bērn|child|junior/.test(t)) return gk ? 0.5 : -0.5;
      if (/men|vīrie/.test(t)) return gm ? 0.5 : -0.2;
      return 0;
    }
    // BSS size system ("US Men", "US Wom", "US JR", "UK", "UK JR", "EIRO JR") decides the
    // table and column outright — no guessing. EU systems need no conversion.
    function planFromSystem(data, values) {
      var sys = String(data.system || '').toUpperCase().trim();
      // "CM AP" / "CM APJ" = mondopoint (foot length in cm), converted with the brand's CM column.
      var m = sys.match(/^(US|UK|CM|EIRO|EUR?)\b\s*(MEN|WOM|JR|APJ|AP)?/);
      if (!m) return null;
      // 02.10.2026: EU-sized products (BSS "EIRO", "EIRO JR") also get the switcher — EU is the
      // source column, the brand table gives UK/US/CM.
      if (m[1] === 'EIRO' || m[1] === 'EU' || m[1] === 'EUR') {
        return plan(m[2] === 'JR' ? Object.assign({}, data, { kids: true }) : data, values, 'EU');
      }
      var src = m[1], kind = m[2] || '';
      if (kind === 'AP') kind = '';
      if (kind === 'APJ') kind = 'JR';
      var want = kind === 'JR' ? /kid|bērn|child|junior/i : kind === 'WOM' ? /women|sieviet/i : kind === 'MEN' ? /^(?!.*women).*(men|vīrie)/i : null;
      var found = null;
      (data.tables || []).forEach(function (t) {
        if (found) return;
        var title = t.title_en || t.title_lv || '';
        var isKids = /kid|bērn|child|junior/i.test(title);
        // An untitled table is the brand's single adult chart (Mavic, Rossignol, ThirtyTwo women).
        if (!title) { if (kind === 'JR') return; }
        else if (want ? !want.test(title) : isKids) return;
        var c = cols(t);
        if (!c[src] || !c.EU) return;
        if (values.every(function (v) { return pos(c[src], v) !== -1; })) {
          var sy = [src].concat(Object.keys(c).filter(function (k) { return k !== src && /^(EU|UK|US|CM)$/i.test(k); }));
          found = { src: src, cols: c, extra: {}, systems: sy };
        }
      });
      return found;
    }
    function plan(data, values, onlySrc) {
      var best = null;
      (data.tables || []).forEach(function (t) {
        var c = cols(t);
        Object.keys(c).forEach(function (src) {
          if (onlySrc && src !== onlySrc) return;
          var hit = values.filter(function (v) { return pos(c[src], v) !== -1; }).length / values.length;
          if (!hit) return;
          // A table that holds every size wins over the gender guess; gender breaks ties.
          var isKidsTable = /kid|bērn|child|junior/i.test(t.title_en || t.title_lv || '');
          if (data.kids && !isKidsTable) return;          // kids product: kids tables only
          if (!data.kids && isKidsTable && hit < 1) return; // adult product: kids table only if it holds every size
          var score = hit + (hit === 1 ? 1 : 0) + genderScore(t.title_en || t.title_lv, data.gender);
          if (!best || score > best.score) best = { score: score, hit: hit, src: src, cols: c, title: t.title_en || t.title_lv || '' };
        });
      });
      if (!best) return null;
      // Sizes missing from the chosen table: borrow the same source column from the brand's
      // other tables (kids tables only when the chosen table is a kids one).
      var kids = /kid|bērn|child|junior/i.test(best.title);
      var extra = {};
      (data.tables || []).forEach(function (t) {
        if (kids !== /kid|bērn|child|junior/i.test(t.title_en || t.title_lv || '')) return; // same kind only
        var c = cols(t);
        if (!c[best.src]) return;
        c[best.src].forEach(function (v, i) {
          if (pos(best.cols[best.src], v) !== -1 || extra[v]) return;
          extra[v] = {};
          Object.keys(c).forEach(function (k) { extra[v][k] = c[k][i]; });
        });
      });
      var covered = values.filter(function (v) { return pos(best.cols[best.src], v) !== -1 || extra[v]; }).length / values.length;
      if (covered < 1) return null; // every size must map, otherwise mixed labels mislead
      best.extra = extra;
      var systems = [best.src].concat(Object.keys(best.cols).filter(function (k) { return k !== best.src && /^(EU|UK|US|CM)$/i.test(k); }));
      var order = { EU: 1, UK: 2, US: 2, CM: 3 };
      systems = [best.src].concat(systems.slice(1).sort(function (a, b) { return (order[a.toUpperCase()] || 9) - (order[b.toUpperCase()] || 9); }));
      return { src: best.src, cols: best.cols, extra: best.extra, systems: systems };
    }
    function label(p, sys, v) {
      if (sys === p.src) return v;
      var i = pos(p.cols[p.src], v);
      var out = i !== -1 ? (p.cols[sys] || [])[i] : (p.extra[v] ? p.extra[v][sys] : '');
      return out ? String(out) : v;
    }
    function run() {
      document.querySelectorAll('script[data-pm-size-sys]').forEach(function (el) {
        var scope = el.closest('.shopify-section') || document;
        var picker = scope.querySelector('variant-picker');
        if (!picker) return;
        var inputs = Array.prototype.filter.call(picker.querySelectorAll('input[type=radio][data-option-name]'), function (i) { return /izm|size/i.test(i.dataset.optionName); });
        var single = picker.querySelector('[data-testid="variant-option-single-value"]');
        var host = inputs.length ? inputs[0].closest('fieldset') : (single ? single.parentElement : null);
        if (!host || host.querySelector('.pm-sys')) return;
        var data; try { data = JSON.parse(el.textContent); } catch (e) { return; }
        var textEls = inputs.length
          ? inputs.map(function (i) { return { v: i.value, el: i.closest('label').querySelector('.variant-option__button-label__text') }; })
          : [{ v: single.dataset.pmOrig || single.textContent.trim(), el: single }];
        var vals = textEls.map(function (t) { return t.v; });
        INFANT = !!data.infant;
        var p = data.system ? planFromSystem(data, vals) : plan(data, vals);
        if (!p || p.systems.length < 2) return;
        var status = host.querySelector('.pm-vo-status__value');
        var statusOrig = status ? (status.dataset.pmOrig || status.textContent.trim()) : '';
        // 02.10.2026: switcher back — EU by default, the shopper can flip to the brand's
        // other systems (UK/US/CM). The choice is remembered across products.
        var eu = p.systems.filter(function (s) { return s.toUpperCase() === 'EU'; })[0];
        if (!eu) return;
        // Audit vs BSS sizetype (24.09.2026): US sizes differ by gender and some "US" brands
        // are really UK in BSS — guessing gave wrong EU on ~20%. Until the product carries its
        // BSS size system, only UK-sourced sizes are converted.
        if (!data.system && !/^(UK|EU)$/i.test(p.src)) return;
        var order = { EU: 1, UK: 2, US: 3, CM: 4 };
        var systems = p.systems.slice().sort(function (a, b) { return (order[a.toUpperCase()] || 9) - (order[b.toUpperCase()] || 9); });
        var bar = document.createElement('span');
        bar.className = 'pm-sys';
        bar.setAttribute('role', 'group');
        bar.setAttribute('aria-label', el.dataset.lv === 'true' ? 'Izmēru sistēma' : 'Size system');
        function show(sys) {
          textEls.forEach(function (t) { if (t.el) { t.el.dataset.pmOrig = t.v; t.el.textContent = label(p, sys, t.v); } });
          if (status && statusOrig) { status.dataset.pmOrig = statusOrig; status.textContent = label(p, sys, statusOrig) + ' ' + sys.toUpperCase(); }
          Array.prototype.forEach.call(bar.children, function (b) { b.setAttribute('aria-pressed', b.dataset.sys === sys ? 'true' : 'false'); });
        }
        systems.forEach(function (sys) {
          var b = document.createElement('button');
          b.type = 'button';
          b.dataset.sys = sys;
          b.textContent = sys.toUpperCase();
          b.addEventListener('click', function (e) { e.preventDefault(); setPref(sys.toUpperCase()); show(sys); });
          bar.appendChild(b);
        });
        (host.querySelector('legend') || host).appendChild(bar);
        var want = pref();
        var start = systems.filter(function (s) { return s.toUpperCase() === want; })[0] || eu;
        show(start);
        host.classList.add('pm-sys-eu');
      });
    }
    var queued = false;
    function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; run(); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();

  (function () {
    if (window.__pmSizeChartReady) return;
    window.__pmSizeChartReady = true;

    var ovl = null, body = null, lastTrigger = null;

    function build() {
      ovl = document.createElement('div');
      ovl.className = 'pm-szc-ovl';
      ovl.setAttribute('role', 'dialog');
      ovl.setAttribute('aria-modal', 'true');
      ovl.hidden = true;
      ovl.innerHTML =
        '<div class="pm-szc-ovl__box">' +
          '<div class="pm-szc-ovl__bar">' +
            '<h2></h2>' +
            '<button type="button" class="pm-szc-ovl__x" aria-label="">' +
              '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="pm-szc-ovl__scroll"></div>' +
        '</div>';
      document.body.appendChild(ovl);
      body = ovl.querySelector('.pm-szc-ovl__scroll');
      ovl.querySelector('.pm-szc-ovl__x').addEventListener('click', close);
      ovl.addEventListener('click', function (e) { if (e.target === ovl) close(); });
    }

    /* "40.0", "40,0" and "40" are the same size to a shopper; treat them alike. */
    function norm(v) {
      var s = String(v == null ? '' : v).trim().toLowerCase().replace(',', '.');
      var n = parseFloat(s);
      return (!isNaN(n) && String(n) === s) ? String(n) : s;
    }

    /* Variants often carry the size plus a qualifier the chart does not repeat —
       "XS/34", "XL/SL". Try the bare size too so those still find their row. */
    function variants(size) {
      var out = [norm(size)];
      var cut = String(size).split('/')[0];
      if (cut && cut !== String(size)) out.push(norm(cut));

      /* Brands write the same size as "2XL" or "XXL" and the variant rarely
         agrees with the chart; treat the two spellings as one. */
      out.slice().forEach(function (v) {
        var digit = /^(\d)xl$/.exec(v);
        if (digit) out.push(new Array(Number(digit[1]) + 1).join('x') + 'l');
        var repeat = /^(x{2,})l$/.exec(v);
        if (repeat) out.push(repeat[1].length + 'xl');
      });
      return out;
    }

    /* Horizon does not always re-render this block when the shopper switches
       variant, so trust the live variant picker over the Liquid attribute and
       fall back to it only when no size input is on the page. */
    function selectedSize(btn) {
      var scope = btn.closest('product-details, .product-details, form, section') || document;
      var fields = scope.querySelectorAll('input[type="radio"]:checked, select');
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        var name = f.getAttribute('name') || '';
        if (!/^(size|izm[eē]rs?)\b/i.test(name)) continue;
        if (f.value) return f.value;
      }
      return btn.getAttribute('data-selected-size') || '';
    }

    function highlight(size) {
      if (!size) return;
      var targets = variants(size);

      /* A chart split into women's / men's / kids' sub-tables uses the same UK
         scale in each, and nothing in the product data says which one applies —
         so a single size lights up in two of them with contradicting
         conversions. Highlighting nothing beats highlighting the wrong row:
         only mark a size when the chart has exactly one table. */
      var tables = body.querySelectorAll('.pm-szc__table');
      if (tables.length !== 1) return;

      tables.forEach(function (table) {
        var match = table.getAttribute('data-match');
        if (!match) return;

        if (table.getAttribute('data-orientation') === 'columns') {
          var row = table.querySelector('tr[data-label="' + CSS.escape(match) + '"]');
          if (!row) return;
          var cells = row.querySelectorAll('td');
          for (var i = 0; i < cells.length; i++) {
            if (targets.indexOf(norm(cells[i].textContent)) < 0) continue;
            // Mark the whole column so every scale lines up with the chosen size.
            table.querySelectorAll('tbody tr').forEach(function (r) {
              var c = r.querySelectorAll('td')[i];
              if (c) c.classList.add(r === row ? 'is-selected' : 'is-selected-line');
            });
            return;
          }
          return;
        }

        var headers = table.querySelectorAll('thead th');
        var col = -1;
        for (var h = 0; h < headers.length; h++) {
          if (headers[h].getAttribute('data-label') === match) { col = h; break; }
        }
        if (col < 0) return;
        var rows = table.querySelectorAll('tbody tr');
        for (var r2 = 0; r2 < rows.length; r2++) {
          var cell = rows[r2].children[col];
          if (!cell || targets.indexOf(norm(cell.textContent)) < 0) continue;
          rows[r2].classList.add('is-selected-line');
          cell.classList.add('is-selected');
          return;
        }
      });
    }

    function close() {
      if (!ovl || ovl.hidden) return;
      ovl.hidden = true;
      body.textContent = '';
      document.documentElement.style.overflow = '';
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    function open(btn) {
      var tpl = btn.parentElement && btn.parentElement.querySelector('[data-pm-size-chart-body]');
      if (!tpl) return;
      if (!ovl) build();

      var titleText = btn.getAttribute('data-modal-title') || '';
      ovl.querySelector('h2').textContent = titleText;
      ovl.querySelector('.pm-szc-ovl__x').setAttribute('aria-label', btn.getAttribute('data-close-label') || 'Close');

      body.textContent = '';
      body.appendChild(tpl.content.cloneNode(true));
      highlight(selectedSize(btn));

      lastTrigger = btn;
      ovl.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      ovl.querySelector('.pm-szc-ovl__x').focus();
    }

    /* Delegated: survives Horizon's variant-change morph of product-details. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pm-size-chart]');
      if (!btn) return;
      e.preventDefault();
      open(btn);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-ski-services"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pmSkiServices) return;
    window.__pmSkiServices = true;

    function sync(svc) {
      var prop = svc.querySelector('.pm-svc__prop');
      if (!prop) return;
      var picked = [];
      svc.querySelectorAll('.pm-svc__check:checked').forEach(function (c) {
        var t = c.getAttribute('data-title') || '';
        var p = c.getAttribute('data-price') || '';
        picked.push(p ? t + ' (' + p + ')' : t);
      });
      /* an empty property would still show up in the cart — drop it instead */
      prop.value = picked.join(', ');
      prop.disabled = picked.length === 0;
    }

    document.addEventListener('change', function (e) {
      var c = e.target;
      if (!c || !c.classList || !c.classList.contains('pm-svc__check')) return;
      var svc = c.closest('.pm-svc');
      if (!svc) return;
      /* pick-one group: ticking one angle unticks the other angles */
      if (c.checked && c.hasAttribute('data-one')) {
        svc.querySelectorAll('.pm-svc__check[data-one]').forEach(function (o) {
          if (o !== c) o.checked = false;
        });
      }
      sync(svc);
    });

    /* Horizon registers its own document-level capture listener for `submit`
       (component.js on:submit binding) before this block's script runs, so a
       submit interception always fires AFTER the theme has already started
       adding the product — re-submitting from there adds the product twice.
       Intercept the button click instead: it happens before submit, so the
       services land in the cart first and the theme's own add runs once. */
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target instanceof Element ? e.target.closest('button[type="submit"]') : null;
        if (!btn || btn.disabled) return;

        var form = btn.form || btn.closest('form');
        if (!form) return;

        /* NOT form.id — a product form contains <input name="id"> for the
           variant, and named controls shadow the element's own properties,
           so form.id returns that input element, never the string. */
        var formId = form.getAttribute('id');
        if (!formId) return;

        var svc = document.querySelector('.pm-svc[data-form="' + formId + '"]');
        if (!svc) return;

        if (btn.__pmSvcDone) {
          btn.__pmSvcDone = false;
          return;
        }

        var items = [];
        svc.querySelectorAll('.pm-svc__check:checked').forEach(function (c) {
          var id = Number(c.getAttribute('data-variant'));
          if (id) items.push({ id: id, quantity: 1 });
        });
        if (!items.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .catch(function () {})
          .finally(function () {
            btn.__pmSvcDone = true;
            btn.click();
          });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-store-availability"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pmStoresDialog) return;
    window.__pmStoresDialog = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pm-stores-open]');
      if (opener) {
        var block = opener.closest('.pm-stores');
        if (block) loadMatrix(block);
        var dlg = document.getElementById(opener.getAttribute('data-pm-stores-open'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
        return;
      }
      var closer = e.target.closest('[data-pm-stores-close]');
      if (closer) {
        var d = closer.closest('dialog');
        if (d) d.close();
        return;
      }
      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('pm-stores-dialog')) {
        e.target.close();
      }
    });

    /* ===== Kartīte (28.10.2026): stāvoklis pa variantiem no [data-pm-sa-data]; izmēra maiņā zīmē uzreiz.
       Ja variantam nav datu (nav custom.stock_matrix), ielādē sekciju tieši tam variantam. ===== */
    function word(d, n) { return n % 10 === 1 && n % 100 !== 11 ? d.one : d.many; }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function render(block, id) {
      var d = block.__pmSa;
      var v = d && d.v[String(id)];
      if (!v) return;
      block.dataset.pmSaVariant = String(id);
      if (v.s === null) { fetchVariant(block, id); return; }
      var n = 0;
      d.names.forEach(function (name) { if (v.s[name]) n++; });
      var multi = Object.keys(d.v).length > 1;
      var offSize = n === 0 && d.on > 0 && multi;
      var row = block.querySelector('[data-pm-sa-status]');
      var line = block.querySelector('[data-pm-sa-line]');
      var cta = block.querySelector('[data-pm-sa-cta]');
      if (row) row.classList.toggle('is-off', n === 0);
      if (line) line.textContent = n > 0 ? d.w + ' ' + n + ' ' + word(d, n) : (offSize ? d.t.sizeW + ' ' + v.l + ' ' + d.t.nowhere : d.t.none);
      if (cta) cta.textContent = offSize ? d.t.ctaOther : d.t.cta;
    }

    function fetchVariant(block, id) {
      if (block.__pmSaFetch === id) return;
      block.__pmSaFetch = id;
      fetch(block.dataset.productUrl + '?variant=' + id + '&section_id=' + block.dataset.sectionId)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-pm-sa-data]');
          var fresh = el && JSON.parse(el.textContent);
          var fv = fresh && fresh.v[String(id)];
          block.__pmSa.v[String(id)].s = fv && fv.s ? fv.s : {};
          if (block.dataset.pmSaVariant === String(id)) render(block, id);
        })
        .catch(function () {})
        .then(function () { if (block.__pmSaFetch === id) block.__pmSaFetch = null; });
    }

    function selectedId(section) {
      var input = section.querySelector('form[action*="/cart/add"] [name="id"]');
      return (input && input.value) || new URL(location.href).searchParams.get('variant');
    }

    document.addEventListener('shopify:product:select', function (e) {
      if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
      var section = e.target.closest('.shopify-section');
      if (!section) return;
      var blocks = section.querySelectorAll('.pm-sa');
      if (!blocks.length) return;
      var apply = function (id) { if (id) blocks.forEach(function (b) { render(b, id); }); };
      if (e.promise && e.promise.then) {
        e.promise.then(function (r) {
          var res = r && r.detail && r.detail.resource;
          apply(res && res.id);
        }).catch(function () {});
      }
      setTimeout(function () { apply(selectedId(section)); }, 400);
    });

    /* Liquid aizpilda store_availabilities tikai IZVĒLĒTAJAM variantam, tāpēc bez stock_matrix sānu logs
       pirmajā atvēršanā ielādē sekciju katram variantam un saliek veikals × izmērs tabulu. */
    function loadMatrix(block) {
      if (block.dataset.pmMatrix || block.dataset.matrix === 'server') return;
      var holder = block.querySelector('[data-pm-stores-variants]');
      var dlg = document.getElementById(block.dataset.dialogId);
      if (!holder || !dlg || !('fetch' in window)) return;
      block.dataset.pmMatrix = '1';

      var variants;
      try { variants = JSON.parse(holder.textContent); } catch (e) { return; }
      var base = block.dataset.productUrl;
      var sid = block.dataset.sectionId;

      Promise.all(variants.map(function (v) {
        return fetch(base + '?variant=' + v.id + '&section_id=' + sid)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var stores = [];
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              doc.querySelectorAll('.pm-store-row').forEach(function (row) {
                if (!row.classList.contains('is-off')) stores.push(row.getAttribute('data-store'));
              });
            }
            return { id: v.id, stores: stores };
          })
          .catch(function () { return { id: v.id, stores: [] }; });
      })).then(function (results) {
        var d = block.__pmSa;
        results.forEach(function (res) {
          if (d && d.v[String(res.id)] && d.v[String(res.id)].s === null) {
            var map = {};
            res.stores.forEach(function (st) { map[st] = -1; });
            d.v[String(res.id)].s = map;
          }
          res.stores.forEach(function (store) {
            var row = dlg.querySelector('.pm-store-row[data-store="' + store.replace(/"/g, '\\"') + '"]');
            if (!row) return;
            var chip = row.querySelector('.pm-store-chip[data-variant="' + res.id + '"]');
            if (chip) chip.classList.remove('is-out');
            if (row.classList.contains('is-off')) {
              row.classList.remove('is-off');
              var status = row.querySelector('.pm-store-row__status');
              if (status) {
                status.innerHTML = '<span class="pm-store-row__dot"></span>' +
                  (dlg.dataset.inWord || status.textContent.trim());
              }
            }
          });
        });
        var on = dlg.querySelectorAll('.pm-store-row:not(.is-off)').length;
        var counter = dlg.querySelector('[data-pm-stores-oncount]');
        if (counter) counter.textContent = on;
        if (d) {
          d.on = on;
          if (block.dataset.pmSaVariant) render(block, block.dataset.pmSaVariant);
        }
        dlg.classList.remove('is-loading');
      });
    }

    function boot(block) {
      var el = block.querySelector('[data-pm-sa-data]');
      if (!el) return;
      try { block.__pmSa = JSON.parse(el.textContent); } catch (e) { return; }
      var section = block.closest('.shopify-section') || document;
      var id = selectedId(section);
      if (id && block.__pmSa.v[String(id)]) render(block, id);
    }

    function bootAll() {
      document.querySelectorAll('.pm-sa').forEach(boot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
